import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import { $primaryColorsGreen } from "@acko-tech/building-blocks.ui.common";
import { resolvePath } from "@utils/resolvePath";

export const Wrapper = styled.div`
  border-radius: 12px;
  border: ${(props) =>
    props.isSelected
      ? `1px solid ${$primaryColorsGreen.normal}`
      : "1px solid #e0e0e8"};
  background-image: url(${resolvePath("/images/planCardGradient.svg")});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 1rem 0 1rem;
  ${(props) => props.styles}
`;

export const PlanName = styled(Text)`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  max-width: 90%;

  color: ${(props) => {
    if (props.disabled) {
      return "#5B5675";
    } else if (props.isVariant) {
      return "#36354C";
    } else {
      return "#451999";
    }
  }}

  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
`;

export const GarageType = styled(Text)`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;

  color: ${(props) => {
    if (props.disabled) {
      return "#5B5675";
    } else {
      return "#7c47e1";
    }
  }};

  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
`;

export const Price = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: #040222;
  margin: 8px 0px 12px;
  display: flex;
  flex-direction: column;

  span {
    color: #5b5675;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
`;

export const Description = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: #36354c;
  display: inline;
`;

export const DescriptionPointer = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 4px 0px;
`;
export const DesciptionPoint = styled(Text)`
  margin-left: 8px
  color: #36354C;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;

  @media(min-width:768px){
    font-size: 14px;
    line-height: 20px;
  }
`;
